/**
 * CollabV3WhereWhen 컴포넌트
 * @description 날짜 줄과 장소 줄(앱 `CollabDetailWhereWhen`). 장소 줄은 오프라인이고 찾을 단서가 있으면
 *   지도 검색으로 열린다 — 앱의 장소 시트(`길찾기 · 지도에서 열기`) 자리다. 온라인은 `Online` 만 쓴다.
 *   장소를 정하지 않았으면 줄이 없다.
 * @example <CollabV3WhereWhen schedule={detail.schedule} place={detail.place} />
 */
import { ChevronRight, MapPinned } from "lucide-react";
import { memo } from "react";

import { collabV3DetailStyles } from "./CollabV3Detail.styles";
import type { CollabV3WhereWhenProps } from "./CollabV3Detail.types";
import CollabV3ScheduleRow from "./CollabV3ScheduleRow";

import { COLLAB_V3_COPY } from "../../constants/collabV3Copy";

const CollabV3WhereWhen = memo<CollabV3WhereWhenProps>(
  ({ schedule, place }) => {
    const styles = collabV3DetailStyles.row;
    const copy = COLLAB_V3_COPY.location;
    const title = place?.isOnline
      ? copy.online
      : (place?.title ?? copy.fallback);
    const texts = (
      <>
        <MapPinned aria-hidden className={styles.icon} />
        <span className={styles.texts}>
          <span className={styles.title}>{title}</span>
          {place?.subtitle ? (
            <span className={styles.meta}>{place.subtitle}</span>
          ) : null}
        </span>
      </>
    );

    return (
      <div className={styles.list}>
        <CollabV3ScheduleRow schedule={schedule} />
        {place?.mapsUrl ? (
          <a
            href={place.mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${title}, ${COLLAB_V3_COPY.a11y.place}`}
            className={`${styles.root} ${styles.link}`}
          >
            {texts}
            <ChevronRight aria-hidden className={styles.chevron} />
          </a>
        ) : place ? (
          <div className={styles.root}>{texts}</div>
        ) : null}
      </div>
    );
  },
);

CollabV3WhereWhen.displayName = "CollabV3WhereWhen";

export default CollabV3WhereWhen;
